import React from 'react';
import { string } from 'prop-types';

export default function BreakView({ breakLabel, breakClassName }) {
    return (
        <li className={breakClassName ? breakClassName : 'break disabled'}>
            <span>{breakLabel}</span>
        </li>
    );
}

BreakView.propTypes = {
    breakLabel: string.isRequired,
    breakClassName: string.isRequired
};
